// 디자이너 서식(프리셋) — 그린 객체 묶음을 저장해 다른 양식에서 불러온다(2026-09-22).

import type {
  LayoutObject,
  SignatureField,
  SignatureLayoutPresetDetailDto,
  SignatureLayoutPresetSummaryDto,
} from '@bhops/shared';
import { apiClient } from './client';

export const signatureLayoutPresetsApi = {
  async list(): Promise<SignatureLayoutPresetSummaryDto[]> {
    const { data } = await apiClient.get<SignatureLayoutPresetSummaryDto[]>(
      '/signature-layout-presets',
    );
    return data;
  },

  async get(id: string): Promise<SignatureLayoutPresetDetailDto> {
    const { data } = await apiClient.get<SignatureLayoutPresetDetailDto>(
      `/signature-layout-presets/${id}`,
    );
    return data;
  },

  async create(
    name: string,
    objects: LayoutObject[],
    fields: SignatureField[],
  ): Promise<{ id: string }> {
    const { data } = await apiClient.post<{ id: string }>('/signature-layout-presets', {
      name,
      objects,
      fields,
    });
    return data;
  },

  async archive(id: string): Promise<void> {
    await apiClient.delete(`/signature-layout-presets/${id}`);
  },
};
